export type TagToSupplierMap = Record<string, string>

/**
 * Finds the supplier for a game based on its tags
 *
 * @param tags - Array of game tags (e.g., ['IJP', 'OPJ'])
 * @param suppliersByTag - Mapping from tag to supplier (e.g., { IJP: 'playson' })
 * @returns The supplier name if a matching tag is found, null otherwise
 */
export function getSupplierFromGameTags(tags: string[] | undefined, suppliersByTag: TagToSupplierMap): string | null {
  if (!tags?.length) {
    return null
  }

  for (const tag of tags) {
    if (suppliersByTag[tag]) {
      return suppliersByTag[tag]
    }
  }

  return null
}
